module.exports = __webpack_public_path__ + "img/pharmacysouth-h-474x356.abb55689.jpg";